/**
 * Campos del form que el navegador del comprador postea a CheckoutRedirect.
 *
 * Vive separado del componente para que la invariante quede cubierta por un test:
 * está MEDIDO contra popme y yamamura que si el form lleva `SessionID`, la tienda NO
 * adopta el carrito que armó core --el BasketID queda en null-- y el comprador llega
 * al checkout vacío. Ese campo viajaba desde 2023.
 *
 * Si alguien necesita agregar un campo, tiene que pasar por acá y el test lo va a
 * frenar si vuelve a aparecer SessionID.
 */
export function checkoutFormFields(basketId) {
  return [{ name: 'BasketID', value: basketId }]
}
